import React from 'react';
import PropTypes from 'prop-types';

import ShareUrlIcons from '../ShareUrlIcons';
import withModal from '../modal/withModal';
import DismissButton from '../DismissButton';

const propTypes = {
  actionProps: PropTypes.shape({
    url: PropTypes.string.isRequired,
    hashtag: PropTypes.string,
    quote: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.node,
  }),
  onRequestClose: PropTypes.func.isRequired,
};

const ShareSheet = ({
  actionProps: { url, hashtag, quote, title = 'Share', content } = {},
  onRequestClose,
}) => {
  return (
    <div className="share-sheet-wrap">
      <div className="share-sheet-header">
        <span className="share-sheet-title">{title}</span>

        <DismissButton onClick={onRequestClose} />
      </div>

      {content && <div className="share-sheet-content">{content}</div>}

      <ShareUrlIcons url={url} hashtag={hashtag} quote={quote} />
    </div>
  );
};

ShareSheet.propTypes = propTypes;

export const SHARE_SHEET_MODAL = 'SHARE_SHEET_MODAL';

export default withModal(ShareSheet, {
  name: SHARE_SHEET_MODAL,
  dismissible: false,
  size: 'sm',
  hideHeader: true,
  className: 'share-sheet-modal modal-floating-panel',
});
